import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_theme_ext_RowClass, bl_cms_theme_hdr_RowClass} from '../../../dbschema';

export class ThemeContainerModel extends BaseContainerModel {

  bl_cms_theme_hdr: bl_cms_theme_hdr_RowClass = new bl_cms_theme_hdr_RowClass();
  bl_cms_theme_exts: bl_cms_theme_ext_RowClass[] = [];
}
